import { useState, useEffect, useRef } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Autocomplete, Badge, Box, CardContent, Container, FormControlLabel, Switch, TextField, Tooltip, Typography } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";

import CrudService from "services/cruds-service";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useMediaQuery from '@mui/material/useMediaQuery'
import { useMaterialUIController } from "context";
import ServiceRequestLinesForm from "cruds/device-management/internal-device-management/view-device/service-request/service-request-lines-form";
import { styled } from '@mui/system'
import MDInput from "components/MDInput";
import { jwtDecode } from "jwt-decode";

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        whiteSpace: 'wrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        height: 'auto',
        padding: '6px',
    },
}))

const FormField = ({ type, label, name, value, onChange, error, ...props }) => (
    <TextField
        type={type}
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        error={!!error}
        helperText={error}
        fullWidth
        margin="normal"
        {...props}
    />
)

const EditRequestService = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [device, setDevice] = useState();
    const [serviceRequest, setServiceRequest] = useState([]);
    const isMobile = useMediaQuery('(max-width:600px)')

    let storedDeviceData = localStorage.getItem('device_params')
    let device_data = storedDeviceData ? JSON.parse(storedDeviceData) : null
    const [smartChecked, setSmartChecked] = useState(false)
    const [selectedValue, setSelectedValue] = useState(null)
    const [controller] = useMaterialUIController()
    const { darkMode } = controller

    const [formData, setFormData] = useState()
    const [confirmFormData, setConfirmFormData] = useState({
        priority_name: '',
        service_item_name: '',
        provider_name: '',
        description: '',
        request_date: '',
        scheduled_date: '',
    })

    const [serviceItems, setServiceItems] = useState([])
    const [priorities, setPriorities] = useState([])
    const [address, setAddress] = useState([])
    const [
        entityAddressItemProviders,
        setEntityAddressItemProviders,
    ] = useState([])
    const [addressItemId, setAddressItemId] = useState(device?.address_item_id)
    const [
        providersRelatedToServiceItem,
        setProvidersRelatedToServiceItem,
    ] = useState([])
    const [errors, setErrors] = useState({})
    const [uneditableField, setUnEditableField] = useState(false)
    const [
        serviceRequestAutoCompletions,
        setServiceRequestAutoCompletions,
    ] = useState([])
    const ServiceRequestsLinesRef = useRef([]);

    const today = new Date().toISOString().split('T')[0]

    const [loader, setLoader] = useState(false)

    useEffect(() => {

        (async () => {
            try {
                setLoader(true)
                let res = await CrudService.getServiceRequest(id)
                const device_id = res.data?.attributes?.device_id
                let deviceRes;
                if (device_id) {
                    deviceRes = await CrudService.getDeviceView(device_id)
                    setDevice(deviceRes?.data?.attributes)
                    setAddressItemId(deviceRes?.data?.attributes?.EntityAddressItem?.address_item_id)
                }

                setServiceRequest(res.data.attributes)
                let serviceReq = res.data.attributes;
                let deviceResp = deviceRes?.data?.attributes
                ServiceRequestsLinesRef.current = []
                setFormData({
                    entity_id: deviceResp?.EntityAddressItem?.Entity?.entity_id,
                    address_id: deviceResp?.EntityAddressItem?.Address?.address_id,
                    address_item_id: deviceResp?.EntityAddressItem?.address_item_id,
                    provider_id: serviceReq ? serviceReq.provider_id : '',
                    service_request_auto_completion_id: selectedValue,
                    item_id: serviceReq ? serviceReq.item_id : '',
                    priority_id: serviceReq ? serviceReq.priority_id : '',
                    description: serviceReq ? serviceReq.description : '',
                    request_date: serviceReq ? serviceReq.request_date : '',
                    device_params: device_data,
                })
                setConfirmFormData((prev) => ({
                    ...prev,
                    entity_name: deviceResp?.EntityAddressItem?.Entity.name
                        ? deviceResp?.EntityAddressItem?.Entity.name
                        : deviceResp?.EntityAddressItem?.Entity.first_name +
                        ' ' +
                        deviceResp?.EntityAddressItem?.Entity.last_name,
                    address_name:
                        deviceResp?.EntityAddressItem?.Address?.street_address1 +
                        deviceResp?.EntityAddressItem?.Address?.street_addresss +
                        ' ' +
                        deviceResp?.EntityAddressItem?.Address?.country +
                        ' ' +
                        deviceResp?.EntityAddressItem?.Address?.city +
                        ' ' +
                        deviceResp?.EntityAddressItem?.Address?.state,
                    address_item_name: deviceResp?.EntityAddressItem?.name,
                }))
            } catch (err) {
                console.error(err);
                return null;
            } finally {
                setLoader(false)
            }
        })();

        (async () => {
            const serviceRequestAutoCompletionsRes = await CrudService.getServiceRequestAutoCompletions()
            setServiceRequestAutoCompletions(serviceRequestAutoCompletionsRes)
        })();
    }, [id]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const prioritiessResponse = await CrudService.getPriorities()
                const priorities = prioritiessResponse.data
                setPriorities(prioritiessResponse.data)

                const serviceItemsResponse = await CrudService.getServiceItems()

                const serviceItems = serviceItemsResponse.data

                if (serviceItems.length == 1) {
                    const serviceItems = serviceItemsResponse.data
                    const providersRelatedToServiceItemRes = await CrudService.getProvidersRelatedToServiceItem(
                        serviceItems[0].item_id,
                    )
                    //  const  providersRelatedToServiceItem = providersRelatedToServiceItemRes.data;
                    const addressItemProvidersResponse = await CrudService.getAddressItemProviders(addressItemId)
                    setEntityAddressItemProviders(addressItemProvidersResponse.data)
                    const providersRelatedToAddressItem = providersRelatedToServiceItemRes.data.filter(
                        (item1) =>
                            addressItemProvidersResponse.data.some(
                                (item2) => item1.provider_id === item2.provider_id,
                            ),
                    )

                    if (providersRelatedToAddressItem.length == 1) {
                        setServiceItems(serviceItemsResponse.data)

                        setProvidersRelatedToServiceItem(providersRelatedToAddressItem)

                        setFormData({
                            ...formData,
                            priority_id: priorities[0].priority_id,
                            item_id: serviceItems[0].item_id,
                            provider_id: providersRelatedToAddressItem[0].provider_id,
                        })
                        setConfirmFormData({
                            ...confirmFormData,
                            priority_name: priorities[0].priority_name,
                            service_item_name: serviceItems[0].item_name,
                            provider_name: providersRelatedToAddressItem[0].provider_name,
                        })
                    }
                } else {
                    setServiceItems(serviceItems)
                }
                const addressItemProvidersResponse = await CrudService.getAddressItemProviders(addressItemId)
                setEntityAddressItemProviders(addressItemProvidersResponse.data)
            } catch (error) {
                console.error('Error fetching data:', error)
            }

            const street_address1 =
                device?.EntityAddressItem?.Address?.street_address1 || ''
            const street_address =
                device?.EntityAddressItem?.Address?.street_addresss || ''
            const country = device?.EntityAddressItem?.Address?.country || ''
            const city = device?.EntityAddressItem?.Address?.city || ''
            const state = device?.EntityAddressItem?.Address?.state || ''
            const address =
                street_address1 +
                street_address +
                ' ' +
                country +
                ' ' +
                city +
                ' ' +
                state
            setAddress(address)

            const token = localStorage.getItem('token')

            if (token) {
                const decoded = jwtDecode(token)
                const role_id = decoded.role_id
                const current_status_id = serviceRequest?.status_type_id

                const service_request_status_info = {
                    role_id: role_id,
                    current_status_id: current_status_id,
                }

                if (service_request_status_info.role_id == '6') {
                    setUnEditableField(true)
                }
                if (service_request_status_info.role_id == '7') {
                    setUnEditableField(false)
                }
            }
        }
        if (Object.values(serviceRequest).length > 0) {
            fetchData()
        }
    }, [device, serviceRequest])

    useEffect(() => {
        const fetchData = async () => {
            try {
                const providersRelatedToServiceItemRes = await CrudService.getProvidersRelatedToServiceItem(
                    formData?.item_id,
                )
                const providersRelatedToAddressItem = providersRelatedToServiceItemRes.data.filter(
                    (item1) =>
                        entityAddressItemProviders.some(
                            (item2) => item1.provider_id === item2.provider_id,
                        ),
                )

                setProvidersRelatedToServiceItem(providersRelatedToAddressItem)
            } catch (error) {
                console.error('Error fetching data:', error)
            }
        }
        fetchData()
    }, [formData?.item_id])

    const handleChange = (event) => {
        setSmartChecked(event.target.checked)
    }
    const clickServiceItem = async (service_item_id, service_item_name) => {

        const providersRelatedToServiceItemRes = await CrudService.getProvidersRelatedToServiceItem(
            service_item_id,
        )
        //  const  providersRelatedToServiceItem = providersRelatedToServiceItemRes.data;
        const addressItemProvidersResponse = await CrudService.getAddressItemProviders(addressItemId)
        setEntityAddressItemProviders(addressItemProvidersResponse.data)
        const providersRelatedToAddressItem = providersRelatedToServiceItemRes.data.filter(
            (item1) =>
                addressItemProvidersResponse.data.some(
                    (item2) => item1.provider_id === item2.provider_id,
                ),
        )

        setProvidersRelatedToServiceItem(providersRelatedToAddressItem)

        if (providersRelatedToAddressItem.length == 1) {
            setFormData({
                ...formData,
                item_id: service_item_id,
                provider_id: providersRelatedToAddressItem[0].provider_id,
            })
            setConfirmFormData({
                ...confirmFormData,
                service_item_name: service_item_name,
                provider_name: providersRelatedToAddressItem[0].provider_name,
            })
        } else {
            setFormData({
                ...formData,
                item_id: service_item_id,
            })
            setConfirmFormData({
                ...confirmFormData,
                service_item_name: service_item_name,
            })
        }
    }

    const handleRadioChange = (event, rowId) => {
        setSelectedValue(rowId) // Set selected row ID when radio button is clicked
        setFormData({
            ...formData,
            service_request_auto_completion_id: rowId,
        })
    }

    const validate = () => {
        let tempErrors = {}
        if (!formData.priority_id) {
            tempErrors.priority = 'Priority is required'
        }
        if (!formData.item_id) {
            tempErrors.serviceItem = 'Service Item is required'
        }
        if (!formData.provider_id) {
            tempErrors.provider = 'Provider is required'
        }

        if (!formData.request_date) {
            tempErrors.requestDate = 'Requested Date is required'
        }

        setErrors(tempErrors)
        return Object.keys(tempErrors).length === 0
    }

    function updateRequestLines(data) {
        ServiceRequestsLinesRef.current = data;
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (validate()) {
                if (formData) {
                    await CrudService.updateServiceRequest(
                        { ...formData, service_request_lines: ServiceRequestsLinesRef.current },
                        serviceRequest?.service_request_id,
                    )
                    navigate('/service-request')
                }
            }
        } catch (error) {
            console.error('handleSubmit', error)
            toast.error(error.error)
        }
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox mt={5} mb={9}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox mt={6} mb={8} textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    Edit Service Request
                                    <StyledBadge
                                        color={
                                            serviceRequest?.StatusOption?.BadgeDetail?.color || 'primary'
                                        }
                                        variant={serviceRequest?.StatusOption?.BadgeDetail?.variant}
                                        badgeContent={
                                            serviceRequest?.StatusOption?.StatusType?.status_name
                                        }
                                        style={{ marginLeft: '50px' }}
                                    ></StyledBadge>
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                        <Card>
                            <Container sx={{ padding: '1rem 0px !important', height: '100%' }}>
                                {/* <MDBox sx={{ height: '50px' }}>
                                    <Typography
                                        variant="h4"
                                        component="h2"
                                        sx={{ display: 'flex', alignItems: 'center' }}
                                    >
                                        Service Request
                                        {(
                                            <StyledBadge
                                                color={
                                                    serviceRequest?.StatusOption?.BadgeDetail?.color || 'primary'
                                                }
                                                variant={serviceRequest?.StatusOption?.BadgeDetail?.variant}
                                                badgeContent={
                                                    serviceRequest?.StatusOption?.StatusType?.status_name
                                                }
                                                style={{ marginLeft: '50px' }}
                                            ></StyledBadge>
                                        )}
                                    </Typography>
                                </MDBox> */}
                                {
                                    !loader &&
                                    <MDBox component="form" method="POST" onSubmit={handleSubmit}>
                                        <CardContent
                                            sx={{
                                                // maxHeight: { xs: '70vh', sm: '80vh', md: '540px', lg: '540px' },
                                                overflowY: 'auto',
                                                overflowX: 'hidden',
                                                background: "none",
                                                padding: 0,
                                            }}
                                        >
                                            {/* Entity */}

                                            <MDInput
                                                fullWidth
                                                sx={{ marginTop: '20px' }}
                                                type="text"
                                                label={
                                                    <Tooltip
                                                        title="The organization or entity making the request."
                                                        placement="right"
                                                        arrow
                                                        disableHoverListener={isMobile} // Disable hover on mobile devices
                                                        disableTouchListener={!isMobile} // Enable touch on mobile devices
                                                        disableFocusListener={!isMobile} // Enable focus-based tooltips on mobile
                                                    >
                                                        <Box>
                                                            <i
                                                                className="fas fa-building"
                                                                style={{ marginRight: '5px' }}
                                                            ></i>
                                                            Entity
                                                        </Box>
                                                    </Tooltip>
                                                }
                                                name="entity"
                                                value={
                                                    device?.EntityAddressItem?.Entity.name
                                                        ? device?.EntityAddressItem?.Entity.name
                                                        : device?.EntityAddressItem?.Entity.first_name +
                                                        ' ' +
                                                        device?.EntityAddressItem?.Entity.last_name
                                                }
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        entity_id: device?.EntityAddressItem?.Entity?.entity_id,
                                                    })
                                                }}
                                                disabled={true}
                                            />

                                            {/* Address  */}

                                            <MDInput
                                                fullWidth
                                                sx={{ marginTop: '20px' }}
                                                type="text"
                                                label={
                                                    <Tooltip
                                                        title="The address where the service will take place."
                                                        placement="right"
                                                        arrow
                                                        disableHoverListener={isMobile} // Disable hover on mobile devices
                                                        disableTouchListener={!isMobile} // Enable touch on mobile devices
                                                        disableFocusListener={!isMobile} // Enable focus-based tooltips on mobile
                                                    >
                                                        <Box>
                                                            <i
                                                                className="fas fa-map-marker-alt"
                                                                style={{ marginRight: '5px' }}
                                                            ></i>
                                                            Address
                                                        </Box>
                                                    </Tooltip>
                                                }
                                                name="address"
                                                value={address}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        address_id: device?.EntityAddressItem?.Address?.address_id,
                                                    })
                                                }}
                                                disabled={true}
                                            />

                                            {/* Address Item */}

                                            <MDInput
                                                fullWidth
                                                sx={{ marginTop: '20px' }}
                                                type="text"
                                                label={
                                                    <Tooltip
                                                        title="The specific location or item needing service."
                                                        placement="right"
                                                        arrow
                                                        disableHoverListener={isMobile} // Disable hover on mobile devices
                                                        disableTouchListener={!isMobile} // Enable touch on mobile devices
                                                        disableFocusListener={!isMobile} // Enable focus-based tooltips on mobile
                                                    >
                                                        <Box>
                                                            <i
                                                                className="fas fa-location-arrow"
                                                                style={{ marginRight: '5px' }}
                                                            ></i>
                                                            Address Item
                                                        </Box>
                                                    </Tooltip>
                                                }
                                                name="address_item"
                                                value={device?.EntityAddressItem?.name}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        address_item_id: device?.EntityAddressItem?.address_item_id,
                                                    })
                                                }}
                                                disabled={true}
                                            />

                                            <Autocomplete
                                                disabled={uneditableField}
                                                options={priorities}
                                                getOptionLabel={(option) => option.priority_name}
                                                defaultValue={serviceRequest?.Priority
                                                    ? serviceRequest.Priority
                                                    : priorities[0] || null
                                                }
                                                onChange={(event, newValue) => {
                                                    setFormData({
                                                        ...formData,
                                                        priority_id: newValue.priority_id,
                                                    })
                                                    setConfirmFormData({
                                                        ...confirmFormData,
                                                        priority_name: newValue.priority_name,
                                                    })
                                                }}
                                                renderInput={(params) => (
                                                    <FormField
                                                        {...params}
                                                        label={
                                                            <Tooltip
                                                                title="Select the urgency for the service request."
                                                                placement="right"
                                                                arrow
                                                                disableHoverListener={isMobile} // Disable hover on mobile devices
                                                                disableTouchListener={!isMobile} // Enable touch on mobile devices
                                                                disableFocusListener={!isMobile} // Enable focus-based tooltips on mobile
                                                            >
                                                                <Box>
                                                                    <i
                                                                        className="fas fa-exclamation-triangle"
                                                                        style={{ marginRight: '5px' }}
                                                                    ></i>
                                                                    Priority
                                                                </Box>
                                                            </Tooltip>
                                                        }
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />

                                            {errors.priority && (
                                                <MDTypography sx={{ color: 'red', fontSize: '12px' }}>
                                                    {errors.priority}
                                                </MDTypography>
                                            )}

                                            <Autocomplete
                                                disabled={uneditableField}
                                                options={serviceItems}
                                                getOptionLabel={(option) => option.item_name}
                                                defaultValue={
                                                    serviceRequest?.ServiceItem
                                                        ? serviceRequest.ServiceItem
                                                        : serviceItems[0]
                                                }
                                                onChange={(event, newValue) => {
                                                    clickServiceItem(newValue.item_id, newValue.item_name)
                                                }}
                                                renderInput={(params) => (
                                                    <FormField
                                                        {...params}
                                                        label={
                                                            <Tooltip
                                                                title="The type of service being requested."
                                                                placement="right"
                                                                arrow
                                                                disableHoverListener={isMobile} // Disable hover on mobile devices
                                                                disableTouchListener={!isMobile} // Enable touch on mobile devices
                                                                disableFocusListener={!isMobile} // Enable focus-based tooltips on mobile
                                                            >
                                                                <Box>
                                                                    <i
                                                                        className="fas fa-tools"
                                                                        style={{ marginRight: '5px' }}
                                                                    ></i>
                                                                    Service Item
                                                                </Box>
                                                            </Tooltip>
                                                        }
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />

                                            {errors.serviceItem && (
                                                <MDTypography sx={{ color: 'red', fontSize: '12px' }}>
                                                    {errors.serviceItem}
                                                </MDTypography>
                                            )}
                                            {/* Provider */}

                                            <Autocomplete
                                                disabled={uneditableField}
                                                options={providersRelatedToServiceItem || []}
                                                defaultValue={
                                                    serviceRequest?.Provider
                                                        ? serviceRequest.Provider
                                                        : providersRelatedToServiceItem[0] || null
                                                }
                                                getOptionLabel={(option) => option?.provider_name}
                                                onChange={(event, newValue) => {
                                                    setFormData({
                                                        ...formData,
                                                        provider_id: newValue ? newValue.provider_id : '',
                                                    })
                                                    setConfirmFormData({
                                                        ...confirmFormData,
                                                        provider_name: newValue ? newValue.provider_name : '',
                                                    })
                                                }}
                                                renderInput={(params) => (
                                                    <FormField
                                                        {...params}
                                                        label={
                                                            <Tooltip
                                                                title="The provider responsible for the service."
                                                                placement="right"
                                                                arrow
                                                                disableHoverListener={isMobile} // Disable hover on mobile devices
                                                                disableTouchListener={!isMobile} // Enable touch on mobile devices
                                                                disableFocusListener={!isMobile} // Enable focus-based tooltips on mobile
                                                            >
                                                                <Box>
                                                                    <i
                                                                        className="fas fa-user-tie"
                                                                        style={{ marginRight: '5px' }}
                                                                    ></i>
                                                                    Provider
                                                                </Box>
                                                            </Tooltip>
                                                        }
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />

                                            {errors.provider && (
                                                <MDTypography sx={{ color: 'red', fontSize: '12px' }}>
                                                    {errors.provider}
                                                </MDTypography>
                                            )}

                                            {/* Description */}

                                            <TextField
                                                disabled={uneditableField}
                                                fullWidth
                                                label={
                                                    <Tooltip
                                                        title="Additional notes or details for the service request."
                                                        placement="right"
                                                        arrow
                                                        disableHoverListener={isMobile} // Disable hover on mobile devices
                                                        disableTouchListener={!isMobile} // Enable touch on mobile devices
                                                        disableFocusListener={!isMobile} // Enable focus-based tooltips on mobile
                                                    >
                                                        <Box>
                                                            <i
                                                                className="fas fa-align-left"
                                                                style={{ marginRight: '5px' }}
                                                            ></i>
                                                            Description
                                                        </Box>
                                                    </Tooltip>
                                                }
                                                sx={{ marginTop: '20px' }}
                                                defaultValue={serviceRequest?.description}
                                                value={formData?.description}
                                                InputLabelProps={{ shrink: true }}
                                                onChange={(event) => {
                                                    setFormData({
                                                        ...formData,
                                                        description: event.target.value,
                                                    })
                                                    setConfirmFormData({
                                                        ...confirmFormData,
                                                        description: event.target.value,
                                                    })
                                                }}
                                            />

                                            {errors.description && (
                                                <MDTypography sx={{ color: 'red', fontSize: '12px' }}>
                                                    {errors.description}
                                                </MDTypography>
                                            )}

                                            {/* request date */}

                                            <TextField
                                                disabled={uneditableField}
                                                sx={{ width: '100%', marginTop: '30px' }}
                                                label={
                                                    <Tooltip
                                                        title="The date you'd like the service to be performed. This is not a confirmed date."
                                                        placement="right"
                                                        arrow
                                                        disableHoverListener={isMobile} // Disable hover on mobile devices
                                                        disableTouchListener={!isMobile} // Enable touch on mobile devices
                                                        disableFocusListener={!isMobile} // Enable focus-based tooltips on mobile
                                                    >
                                                        <Box>
                                                            <i
                                                                className="fas fa-calendar-alt"
                                                                style={{ marginRight: '5px' }}
                                                            ></i>
                                                            Requested Date
                                                        </Box>
                                                    </Tooltip>
                                                }
                                                type="date"
                                                defaultValue={serviceRequest?.request_date}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ min: today }}
                                                value={formData?.request_date}
                                                onChange={(event) => {
                                                    setFormData({
                                                        ...formData,
                                                        request_date: event.target.value,
                                                    })
                                                    setConfirmFormData({
                                                        ...confirmFormData,
                                                        request_date: event.target.value,
                                                    })
                                                }}
                                            />

                                            {errors.requestDate && (
                                                <MDTypography sx={{ color: 'red', fontSize: '12px' }}>
                                                    {errors.requestDate}
                                                </MDTypography>
                                            )}


                                            <ServiceRequestLinesForm updateRequestLines={updateRequestLines} lines={serviceRequest.ServiceRequestsLines ?? []} service_request_id={serviceRequest?.service_request_id} />
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={smartChecked}
                                                        onChange={handleChange}
                                                        color="secondary"
                                                        sx={{
                                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                                color: 'white', // Thumb (knob) color when checked
                                                                '& + .MuiSwitch-track': {
                                                                    backgroundColor: 'blue', // Track (background) color when checked
                                                                },
                                                            },
                                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                opacity: 1, // Ensures track visibility
                                                            },
                                                            '& .MuiSwitch-track': {
                                                                backgroundColor: 'lightgray', // Track color when unchecked
                                                                opacity: 1, // Ensures visibility of track
                                                            },
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <span style={{ fontSize: '0.8rem', fontWeight: '300' }}>
                                                        Smart Servcie
                                                        <Tooltip
                                                            placement="right"
                                                            title="Enable Smart Service to automate actions based on specific conditions."
                                                        >
                                                            <i className="bi bi-magic"></i>
                                                        </Tooltip>
                                                    </span>
                                                }
                                            />

                                            {smartChecked && (
                                                <>
                                                    <Typography sx={{ color: darkMode ? '#fff' : '#344767' }}>Select Smart Service Criteria</Typography>
                                                    <div style={{ overflowX: 'auto', color: darkMode ? '#fff' : '#344767' }}>
                                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                            <thead>
                                                                <tr style={{ fontSize: '0.825rem', textAlign: 'left' }}>
                                                                    <th
                                                                        style={{
                                                                            width: '20%',
                                                                            padding: '8px',
                                                                            border: '1px solid #ddd',
                                                                        }}
                                                                    >
                                                                        Select
                                                                    </th>
                                                                    <th
                                                                        style={{
                                                                            width: '30%',
                                                                            padding: '8px',
                                                                            border: '1px solid #ddd',
                                                                        }}
                                                                    >
                                                                        Service Name
                                                                    </th>
                                                                    <th
                                                                        style={{
                                                                            width: '50%',
                                                                            padding: '8px',
                                                                            border: '1px solid #ddd',
                                                                        }}
                                                                    >
                                                                        Description
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {serviceRequestAutoCompletions &&
                                                                    serviceRequestAutoCompletions.map((row) => (
                                                                        <tr key={row.id} style={{ fontSize: '0.8rem' }}>
                                                                            <td
                                                                                style={{
                                                                                    width: '20%',
                                                                                    textAlign: 'center',
                                                                                    padding: '8px',
                                                                                    border: '1px solid #ddd',
                                                                                }}
                                                                            >
                                                                                <input
                                                                                    type="radio"
                                                                                    checked={selectedValue === row.id}
                                                                                    onChange={(event) =>
                                                                                        handleRadioChange(event, row.id)
                                                                                    }
                                                                                    value={row.id}
                                                                                />
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    width: '30%',
                                                                                    padding: '8px',
                                                                                    border: '1px solid #ddd',
                                                                                }}
                                                                            >
                                                                                {row.name}
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    width: '50%',
                                                                                    padding: '8px',
                                                                                    border: '1px solid #ddd',
                                                                                }}
                                                                            >
                                                                                {row.description}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </>
                                            )}
                                        </CardContent>
                                        <MDBox
                                            ml="auto"
                                            // sx={{ position: 'absolute', bottom: '10px', right: '10px' }}
                                            mt={1}
                                            display="flex"
                                            justifyContent="flex-end"
                                        >
                                            <MDButton color="secondary" onClick={() => navigate('/service-request')}>
                                                Back
                                            </MDButton>

                                            <Tooltip title="Button to submit the request. Sends the service request to the appropriate provider for action.">
                                                <MDButton
                                                    onClick={handleSubmit}
                                                    style={{
                                                        backgroundColor: 'blue',
                                                        color: 'white',
                                                        marginLeft: '10px',
                                                    }}
                                                >
                                                    <i
                                                        class="fas fa-paper-plane"
                                                        style={{ marginRight: '5px' }}
                                                    ></i>
                                                    Submit
                                                </MDButton>
                                            </Tooltip>
                                        </MDBox>
                                    </MDBox>
                                }
                            </Container>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default EditRequestService;
